import { Box, Group, Text, Stack } from '@mantine/core'
import { SectionLabel } from './SectionLabel'

function Meter({ label, value }) {
  const pct = Math.max(0, Math.min(100, Math.round(value || 0)))
  return (
    <Group gap="sm" wrap="nowrap" align="center">
      <Text size="xs" c="dimmed" w={56} style={{ flexShrink: 0 }}>{label}</Text>
      <Box className="g2-meter-track" style={{ flex: 1 }}>
        <div className="g2-meter-fill" style={{ width: `${pct}%` }} />
      </Box>
      <Text size="xs" c="dimmed" w={36} ta="right" style={{ flexShrink: 0 }}>{pct}%</Text>
    </Group>
  )
}

// Always-visible progress. Stays mounted through resolution beats and the
// debrief (Sonia's "status visible at all times"). Story + thread progress; live
// signal counts are deliberately omitted mid-story (open question — they may
// bias choices) and surface during reflections instead.
export function StatusStrip({ overallProgress, threadProgress }) {
  return (
    <Box p="md" style={{ borderBottom: '1px solid var(--bw-panel-border)' }}>
      <SectionLabel>Status</SectionLabel>
      <Stack gap={8}>
        <Meter label="Story" value={overallProgress} />
        {typeof threadProgress === 'number' && <Meter label="Thread" value={threadProgress} />}
      </Stack>
    </Box>
  )
}
